import { render, staticRenderFns } from "./CobrancaListagemTabela.vue?vue&type=template&id=4b13c2e0&scoped=true"
import script from "./CobrancaListagemTabela.vue?vue&type=script&lang=js"
export * from "./CobrancaListagemTabela.vue?vue&type=script&lang=js"
import style0 from "./CobrancaListagemTabela.vue?vue&type=style&index=0&id=4b13c2e0&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b13c2e0",
  null
  
)

export default component.exports